import type { PropsWithChildren } from "react";
import { useSession } from "../auth/sessionContext";
import { InlineNotice } from "../components/Feedback/InlineNotice";
import { hasWorkflowProjectsAccess } from "./workflowAccess";
import styles from "./WorkflowsPage.module.css";

export function WorkflowProjectsRouteGuard({ children }: PropsWithChildren) {
  const session = useSession();
  if (!hasWorkflowProjectsAccess(session)) {
    return <section className={styles.denied} data-status-code="403" aria-label="Projects unavailable"><InlineNotice tone="error" title="403 — Projects unavailable">Customer Projects are not enabled for this workspace.</InlineNotice></section>;
  }
  return children;
}
